// Shared task blocks reused across multiple days in the schedule.

export interface Task {
  cat: string;
  label: string;
  time: string;
  duration: string;
  personal?: boolean;
  trackId?: string;
  /** Added later by the schedule processor. */
  id?: string;
}

export const morningRoutine = (toddlerLearning = true): Task[] => [
  { cat: "🌅 Morning Routine", label: "Wake up, drink water, 5 min stretch",  time: "7:00 AM", duration: "5 min" },
  { cat: "🌅 Morning Routine", label: "Skincare — cleanse, moisturize, SPF",   time: "7:05 AM", duration: "10 min", personal: true },
  { cat: "🌅 Morning Routine", label: "Get dressed, make bed",                 time: "7:15 AM", duration: "10 min" },
  { cat: "👶 Toddler Dev",     label: "Toddler up — diaper, dress & breakfast",time: "7:30 AM", duration: "30 min" },
  ...(toddlerLearning
    ? [{ cat: "👶 Toddler Dev", label: "Toddler learning time", time: "8:00 AM", duration: "20–30 min", personal: true }]
    : []),
];

export const weekendMorning = (): Task[] => [
  { cat: "🌅 Morning Routine", label: "Wake up, drink water, 5 min stretch",  time: "7:00 AM", duration: "5 min" },
  { cat: "🌅 Morning Routine", label: "Skincare — cleanse, moisturize, SPF",   time: "7:05 AM", duration: "10 min", personal: true },
  { cat: "🌅 Morning Routine", label: "Get dressed, make bed",                 time: "7:15 AM", duration: "10 min" },
  { cat: "👶 Toddler Dev",     label: "Toddler up — diaper, dress & breakfast",time: "7:30 AM", duration: "1 hr" },
];

export const mealsBlock = (): Task[] => [
  { cat: "👶 Toddler Dev",       label: "Toddler morning snack",       time: "10:30 AM", duration: "~10 min" },
  { cat: "👶 Toddler Dev",       label: "Toddler & family lunch",      time: "11:30 AM", duration: "20–30 min" },
  { cat: "👶 Toddler Dev",       label: "Toddler afternoon snack",     time: "3:30 PM",  duration: "~10 min" },
  { cat: "🌙 Evening Wind-Down", label: "Cook family dinner",          time: "5:30 PM",  duration: "30–45 min" },
  { cat: "🌙 Evening Wind-Down", label: "Family dinner together",      time: "6:15 PM",  duration: "20–30 min" },
];

export const napBlock = (): Task[] => [
  { cat: "😴 Toddler Nap", label: "Toddler nap begins", time: "12:00 PM", duration: "2.5 hrs" },
  { cat: "😴 Toddler Nap", label: "Toddler wakes",      time: "2:30 PM",  duration: "—" },
];

export const toddlerBedtime = (): Task[] => [
  { cat: "🌙 Toddler Bedtime", label: "Bath, PJs, brush teeth",       time: "7:00 PM", duration: "20 min" },
  { cat: "🌙 Toddler Bedtime", label: "Stories & wind-down cuddles",   time: "7:20 PM", duration: "15 min" },
  { cat: "🌙 Toddler Bedtime", label: "Toddler down for bed",          time: "7:35 PM", duration: "~5 min" },
];

export const windDown = (coupleTime = false, aloneTime = true): Task[] => [
  { cat: "✅ Reset",     label: "Quick tidy — kitchen & common areas", time: "8:00 PM", duration: "~15 min" },
  { cat: "🏠 Home Mgmt", label: "Set out clothes & bag for tomorrow",  time: "8:15 PM", duration: "~5 min" },
  ...(coupleTime
    ? [{ cat: "🔗 Connection", label: "Intentional time with husband — no phones", time: "8:30 PM", duration: "30–45 min", personal: true }]
    : []),
  ...(aloneTime
    ? [{ cat: "🌙 Evening Wind-Down", label: "Alone time — read, journal or decompress", time: coupleTime ? "9:15 PM" : "8:30 PM", duration: "30–45 min", personal: true }]
    : []),
  { cat: "🌙 Evening Wind-Down", label: "Skincare night routine",  time: "10:00 PM", duration: "10 min", personal: true },
  { cat: "🌙 Evening Wind-Down", label: "Lights out",              time: "11:00 PM", duration: "—" },
];
